module.exports = __webpack_public_path__ + "static/media/gmail-edit.4c03dd5b.png";